// extracted by mini-css-extract-plugin
export default {"pagination":"Paginations_pagination__mVuWm"};